import React from 'react';

const formatDate = (iso) => {
	if (!iso) return '';
	const d = new Date(iso);
	if (isNaN(d)) return iso;
	const dd = String(d.getDate()).padStart(2, '0');
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const yyyy = d.getFullYear();
	return `${dd}.${mm}.${yyyy}`;
};

const MetricMeasurementsModal = ({ isOpen, onClose, measurements = [], unit = '' }) => {
	if (!isOpen) return null;

	const list = Array.isArray(measurements) ? [...measurements].slice().reverse() : [];

	return (
		<div className='fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50'>
			<div className='bg-white rounded-lg shadow-lg w-full max-w-lg mx-4'>
				<div className='p-6'>
					<h2 className='text-xl font-bold mb-4 flex items-center'>
						<span className='mr-2'>📊</span>
						Measurements
					</h2>

					{list.length === 0 ? (
						<p className='text-sm text-gray-600'>No measurements recorded.</p>
					) : (
						<ul className='space-y-3'>
							{list.map((m, idx) => (
								<li key={m.date + idx} className='border rounded-md p-3'>
									<div className='flex justify-between items-center'>
										<span className='text-sm font-medium'>
											{m.value} {unit}
										</span>
										<span className='text-xs text-gray-500'>{formatDate(m.date)}</span>
									</div>
									{m.note && <div className='mt-2 text-sm text-gray-700'>{m.note}</div>}
								</li>
							))}
						</ul>
					)}
				</div>

				<div className='bg-gray-50 px-6 py-3 rounded-b-lg flex justify-end'>
					<button
						onClick={onClose}
						className='px-4 py-2 bg-gray-300 text-gray-700 rounded-md text-sm hover:bg-gray-400'
					>
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default MetricMeasurementsModal;
